import { Link } from "react-router-dom";
import type { Special } from "@/types";

interface SpecialCardProps {
  special: Special;
}

export default function SpecialCard({ special }: SpecialCardProps) {
  return (
    <Link
      to={`/special/${special.id}`}
      className="group relative flex aspect-[16/10] cursor-pointer flex-col justify-end overflow-hidden rounded-lg bg-foreground-950"
    >
      <img
        src={special.cover}
        alt={`专题《${special.title}》主视觉`}
        title={`${special.title} 专题策划`}
        className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent"></div>
      <div className="relative p-4">
        <span className="mb-2 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-background-50">
          <i className="ri-bookmark-3-line text-[10px]"></i>
          专题策划
        </span>
        <h3 className="line-clamp-1 text-base font-bold text-background-50">{special.title}</h3>
        <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-background-100/85">
          {special.intro}
        </p>
      </div>
    </Link>
  );
}